import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';
import styles from './ProcessingLoader.module.css';

type IconProps = { size?: number; color?: string };
const ChartIcon = FiBarChart2 as React.FC<IconProps>;

export type ProcessingLoaderProps = {
  title?: string;
  subtitle?: string;
  /**
   * Sits inside the spinning ring. Defaults to a chart glyph -- pass a
   * domain icon when the page has one, so the wait reads as "this page is
   * working" rather than as a generic spinner.
   */
  icon?: React.ReactNode;
  'data-testid'?: string;
};

export const ProcessingLoader = ({
  title = 'Please wait a moment',
  subtitle = 'Processing and analyzing your data...',
  icon,
  'data-testid': dataTestId
}: ProcessingLoaderProps) => (
  <div className={styles.wrap} data-testid={dataTestId} role="status" aria-live="polite">
    <div className={styles.loader}>
      <div className={styles.ring} />
      <div className={styles.spinner} />
      <div className={styles.badge}>{icon ?? <ChartIcon size={26} />}</div>
    </div>
    <p className={styles.title}>{title}</p>
    <p className={styles.subtitle}>{subtitle}</p>
  </div>
);

export default ProcessingLoader;
